<template>
  <div class="container-fluid">
    <vk-offcanvas flipped overlay stuck :show.sync="showOffCanvas">
    </vk-offcanvas>

    <div class="col-xl-12 col-lg-12 col-md-12">
      <div
        class="page-content__header-description"
        style="display: flex; margin-bottom: 20px;"
      >
        <h2 style="flex: 1;">Customer Billing</h2>
        <div
          v-if="usertype != 'customer admin'"
          style="display: flex; margin-right: 20px;"
        >
          <span style="flex: 1; align-items: center; margin-right: 10px;">
            <router-link class="btn btn-primary" to="/user/billing"
              >Setup Billing</router-link
            >
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="container-fluid">
            <can I="read" a="user">
              <BillingListing />
            </can>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BillingListing from "@/components/pages/adminBilling/BillingListing.vue";
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton
  // ...
} from "element-ui";

import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";

export default {
  name: "AdminBilling",
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton,
    BillingListing
  },
  data() {
    return {
      showOffCanvas: false,
      activeTab: "user_list",
      usertype: localStorage.roleType
    };
  },
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/pages/adminBilling/AdminBilling.vue